import { useEffect, useState } from "react";

import {
    GUEST_WISHLIST_CHANGED_EVENT,
    GUEST_WISHLIST_SYNC_STATE_CHANGED_EVENT,
    getGuestWishlist,
    getGuestWishlistSyncState,
    type GuestWishlistSyncState,
} from "src/utils/guestWishlist";

const useGuestWishlistState = () => {
    const [slugs, setSlugs] = useState<string[]>(() => getGuestWishlist());
    const [syncState, setSyncState] = useState<GuestWishlistSyncState>(() => getGuestWishlistSyncState());

    useEffect(() => {
        const syncGuestWishlistState = () => {
            setSlugs(getGuestWishlist());
        };

        const syncGuestWishlistSyncState = () => {
            setSyncState(getGuestWishlistSyncState());
        };

        window.addEventListener(GUEST_WISHLIST_CHANGED_EVENT, syncGuestWishlistState);
        window.addEventListener(GUEST_WISHLIST_SYNC_STATE_CHANGED_EVENT, syncGuestWishlistSyncState);

        return () => {
            window.removeEventListener(GUEST_WISHLIST_CHANGED_EVENT, syncGuestWishlistState);
            window.removeEventListener(GUEST_WISHLIST_SYNC_STATE_CHANGED_EVENT, syncGuestWishlistSyncState);
        };
    }, []);

    return { slugs, syncState };
};

export default useGuestWishlistState;
